enum CurrencySymbols {
  Usd = '$',
}

export default CurrencySymbols;
